import {
  REQUEST_NAVBAR_STATS,
  RECEIVE_NAVBAR_STATS,
} from "./navbarStatsActions";

const _nullState = {
  brandPicture: {},
  brands: [],
  counts: {
    products: 0,
    videos: null,
    influencers: 0,
  },
  currentBrand: {},
  current_user: {
    first_name: "",
    last_name: "",
    _id: "",
  },
  priority_notification: {
    new_videos_count: 0,
    trending_videos_count: 0,
  },
  roles: [],
  loadingStats: false,
};

export const navbarStatsReducer = (state = _nullState, payload = {}) => {
  const { type, data } = payload;
  switch (type) {
    case REQUEST_NAVBAR_STATS:
      return { ...state, loadingStats: true };
    case RECEIVE_NAVBAR_STATS:
      return { ...data, loadingStats: false };
    default:
      return state;
  }
};
